<template>
  <div style="padding: 15px">
    <el-checkbox v-model="multiple" label="是否多选" size="large" />
    <el-button type="primary" @click="showDialog" style="margin-left: 15px">点击</el-button>
    <LsSelectUser
      :show.sync="visible"
      :multiple="multiple"
      :user="users"
      draggable
      @submit="submit"
      @close="closeDialog"
    ></LsSelectUser>
  </div>
</template>

<script>
import LsSelectUser from "./index.vue";
export default {
  name: 'LsSelectUserPage',
  components: {
    LsSelectUser
  },
  data() {
    return {
      visible: false,
      multiple: false,
      users: []
    }
  },
  mounted() {
    this.users = [];
  },
  methods: {
    showDialog() {
      this.visible = true;
    },

    submit(data) {
      let temp = [];
      data.map((item) => {
        temp.push(item.userId);
      });
      this.users = temp;
    },

    closeDialog() {
      console.log("关闭弹窗close");
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
